import { GridColDef } from "@mui/x-data-grid-pro";
import {
  DeleteIcon,
  GKButton,
  GKClientDataGrid,
  Grid2,
  IconButton,
  Show,
} from "components";
import { useMutation } from "hooks/useQueries";
import { useState } from "react";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField, refetchQuery } from "utils/helpers";
import EmailEditModal from "./EmailEditModal";

interface Props {
  data: any;
  isLoading: boolean;
}

const EmailReply = (props: Props) => {
  const { data, isLoading } = props;

  const [replyData, setReplyData] = useState({});

  const [openReplyEmailModal, setOpenReplyEmailModal] = useState(false);

  const { mutate: handleDeleteReplyEmail } = useMutation({
    mutationFn: (id: number) =>
      axiosInstance?.delete(`reply-email-portfolio/${id}/`),
    onSuccess: () => {
      refetchQuery("GET_REPLAY_EMAIL_LIST");
    },
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Email", "email", 0, 1),
    },
    {
      ...extraColumnsField("Portfolio Count", "portfolio", 0, 1),
      type: "number",
      valueGetter: (params) => params.row?.portfolio?.length || "0",
    },
    {
      ...extraColumnsField("Action", "action", 0, 1),
      align: "right",
      headerAlign: "right",
      renderCell: (params) => {
        return (
          <IconButton
            color="error"
            className="outline"
            onClick={(event) => {
              event?.stopPropagation();
              handleDeleteReplyEmail(params.row.id);
            }}
          >
            <DeleteIcon />{" "}
          </IconButton>
        );
      },
    },
  ];

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <GKClientDataGrid
          name="replyTo"
          columns={columns}
          loading={isLoading}
          maxHeight={"calc(100vh - 410px)"}
          rows={data || []}
          onRowClick={(params) => {
            setReplyData(params.row);
            setOpenReplyEmailModal(true);
          }}
          columnsButton={false}
          headerComponent={
            <GKButton
              variant="contained"
              loading={false}
              onClick={(e) => {
                e.stopPropagation();
                setReplyData({});
                setOpenReplyEmailModal(true);
              }}
            >
              Add new
            </GKButton>
          }
        />
      </Grid2>
      <Show.When isTrue={openReplyEmailModal}>
        <EmailEditModal
          open={openReplyEmailModal}
          setOpen={setOpenReplyEmailModal}
          data={replyData}
        />
      </Show.When>
    </Grid2>
  );
};

export default EmailReply;
